import { render, staticRenderFns } from "./addAreaTimeLimit.vue?vue&type=template&id=4bc20c5c&scoped=true"
import script from "./addAreaTimeLimit.vue?vue&type=script&lang=js"
export * from "./addAreaTimeLimit.vue?vue&type=script&lang=js"
import style0 from "./addAreaTimeLimit.vue?vue&type=style&index=0&id=4bc20c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc20c5c",
  null
  
)

export default component.exports